module.exports = __webpack_public_path__ + "img/image-3.880a3de4.png";